/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Hero_ContributedInputs */

const id_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontribusi`)
};

const ms_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disumbangkan`)
};

const da_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidraget`)
};

const de_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beigetragen`)
};

const en_us2_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contributed`)
};

const es_es2_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuidas`)
};

const es_mx2_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuidas`)
};

const fil_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-contribute`)
};

const fr_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribués`)
};

const it_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuite`)
};

const hu_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hozzájárult`)
};

const nl_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijgedragen`)
};

const no_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidratt`)
};

const pl_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodane`)
};

const pt_br2_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuído`)
};

const pt_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuídas`)
};

const ro_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contribuite`)
};

const fi_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisätty`)
};

const sv_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bidragit`)
};

const vi_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đóng góp`)
};

const tr_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katkıda bulunulan`)
};

const cs_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přispěno`)
};

const bg_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допринесени`)
};

const ru_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Внёс вклад`)
};

const uk_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Залишено`)
};

const ar_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساهم بها`)
};

const hi_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`योगदान दिया`)
};

const th_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีส่วนร่วม`)
};

const ja_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`投稿数`)
};

const zh_cn2_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贡献`)
};

const zh_hant1_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貢獻`)
};

const ko_profile_hero_contributed = /** @type {(inputs: Profile_Hero_ContributedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기여`)
};

/**
* | output |
* | --- |
* | "Contributed" |
*
* @param {Profile_Hero_ContributedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_hero_contributed = /** @type {((inputs?: Profile_Hero_ContributedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hero_ContributedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_hero_contributed(inputs)
	if (locale === "ms") return ms_profile_hero_contributed(inputs)
	if (locale === "da") return da_profile_hero_contributed(inputs)
	if (locale === "de") return de_profile_hero_contributed(inputs)
	if (locale === "en-US") return en_us2_profile_hero_contributed(inputs)
	if (locale === "es-ES") return es_es2_profile_hero_contributed(inputs)
	if (locale === "es-MX") return es_mx2_profile_hero_contributed(inputs)
	if (locale === "fil") return fil_profile_hero_contributed(inputs)
	if (locale === "fr") return fr_profile_hero_contributed(inputs)
	if (locale === "it") return it_profile_hero_contributed(inputs)
	if (locale === "hu") return hu_profile_hero_contributed(inputs)
	if (locale === "nl") return nl_profile_hero_contributed(inputs)
	if (locale === "no") return no_profile_hero_contributed(inputs)
	if (locale === "pl") return pl_profile_hero_contributed(inputs)
	if (locale === "pt-BR") return pt_br2_profile_hero_contributed(inputs)
	if (locale === "pt") return pt_profile_hero_contributed(inputs)
	if (locale === "ro") return ro_profile_hero_contributed(inputs)
	if (locale === "fi") return fi_profile_hero_contributed(inputs)
	if (locale === "sv") return sv_profile_hero_contributed(inputs)
	if (locale === "vi") return vi_profile_hero_contributed(inputs)
	if (locale === "tr") return tr_profile_hero_contributed(inputs)
	if (locale === "cs") return cs_profile_hero_contributed(inputs)
	if (locale === "bg") return bg_profile_hero_contributed(inputs)
	if (locale === "ru") return ru_profile_hero_contributed(inputs)
	if (locale === "uk") return uk_profile_hero_contributed(inputs)
	if (locale === "ar") return ar_profile_hero_contributed(inputs)
	if (locale === "hi") return hi_profile_hero_contributed(inputs)
	if (locale === "th") return th_profile_hero_contributed(inputs)
	if (locale === "ja") return ja_profile_hero_contributed(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_hero_contributed(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_hero_contributed(inputs)
	return ko_profile_hero_contributed(inputs)
});
export { profile_hero_contributed as "profile.hero.contributed" }